module.exports = __webpack_public_path__ + "static/media/full.a2cb0e31.svg";